import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

/**
 * Service to show notifications
 */
@Injectable()
export class NotificationService {
    constructor(private translate: TranslateService) {

    }

    /**
     * Displays a toast to the user
     * @param key i18n key from the resource bundle. See src/assets/i18n/en.json
     * @param interpolateParams
     */
    displayToast(key: string | Array<string>, interpolateParams?: Object) {
        this.translate.get(key, interpolateParams).subscribe((translation: string) => {
            alert(translation);
        });
    }

    /**
     * Displays a toast to the user
     * @param message
     */
    displayTranslatedToast(message: string) {
        alert(message);
    }

    /**
     * Displays an alert to the user with an OK button
     * @param title key i18n key from the resource bundle. See src/assets/i18n/en.json
     * @param subTitle key i18n key from the resource bundle. See src/assets/i18n/en.json
     * @param interpolateParams
     */
    displayAlert(title: string, subTitle: string, interpolateParams?: Object): void {
        // It would be preferable here to pass an array of lookup keys to translate.get(), however ng2-translate has a bug which can
        // cause the returned translations to be assigned to the wrong keys.
        this.translate.get(subTitle, interpolateParams).subscribe((subTitleTranslation: string) => {
            this.translate.get("woa.button.common.ok").subscribe((okTranslation: string) => {
                if (title) {
                    this.translate.get(title, interpolateParams).subscribe((titleTranslation: string) => {
                        alert(titleTranslation);
                    });
                } else {
                    alert(subTitleTranslation);
                }
            });
        });
    }
}
